<p-messages [closable]="false" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'">
</p-messages>
<ng-template #conInternet>
    <p-messages [closable]="false" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'">
    </p-messages>
</ng-template>